import { apiSlice } from './apiSlice';
import {PROMOTIONS_URL} from "../constants";

export const promotionApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getEvents: builder.query({
            query: () => ({
                url: PROMOTIONS_URL,
            }),
            keepUnusedDataFor: 5,
            providesTags: ['Event'],
        }),
        getEventById: builder.query({
            query: (id) => ({
                url: `${PROMOTIONS_URL}/${id}`,
            }),
            keepUnusedDataFor: 5,
        }),
        getActiveEvent: builder.query({
            query: () => ({
                url: `${PROMOTIONS_URL}/active`,
            }),
            keepUnusedDataFor: 5,
        }),
        createEvent: builder.mutation({
            query: (data) => ({
                url: PROMOTIONS_URL,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Event'],
        }),
        updateEvent: builder.mutation({
            query: (data) => ({
                url: `${PROMOTIONS_URL}/${data._id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Event'],
        }),
        deleteEvent: builder.mutation({
            query: (id) => ({
                url: `${PROMOTIONS_URL}/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Event'],
        }),
    }),
});

export const {
    useGetEventsQuery,
    useGetEventByIdQuery,
    useGetActiveEventQuery,
    useCreateEventMutation,
    useUpdateEventMutation,
    useDeleteEventMutation,
} = promotionApiSlice;
